import { createAction, handleActions } from 'redux-actions';
import { api } from "api";
import {initialize as initializeForm} from "redux-form";
import {NotificationManager} from "react-notifications";
import {push} from "react-router-redux";
import _ from "lodash";

const LOADER = 'LOADER_CONFIG_PLATAFORMA';
const ITEM_DATA = 'ITEM_CONFIG_PLATAFORMA';

// -----------------------------------
// Pure Actions
// -----------------------------------

const setLoader = loader => ({
    type: LOADER,
    loader,
});

const setItem = item => ({
    type: ITEM_DATA,
    item,
});


// ------------------------------------
// Actions
// ------------------------------------


const leer = () => (dispatch) => {
    dispatch(setLoader(true));
    api.get('conf_plataforma').then((response) => {
        if (response.iva != null) {
            response.iva = response.iva * 100;
        }
        dispatch(setItem(response));
        dispatch(initializeForm('ConfigPlataformaForm', response));
    }).catch(() => {
    }).finally(() => {
        dispatch(setLoader(false));
    });
};

const crear = data => (dispatch) => {
    dispatch(setLoader(true));
    api.post('conf_plataforma', {...data, iva: data.iva / 100}).then(() => {
        NotificationManager.success('Registro actualizado', 'Éxito', 3000);
        dispatch(leer());
        // dispatch(push('/CONFIG_PLATAFORMA'));
    }).catch((error) => {
        let mensaje = "Error en la creación";
        NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
}

const cambiarHoraClases = (resta=null) => (dispatch) => {
    dispatch(setLoader(true));
    api.put('conf_plataforma/cambiar_hora_clases', {resta}).then(() => {
        let mensaje = "Se ha incrementado una hora a todas las clases a futuro";
        if (resta)
            mensaje = "Se ha restado una hora a todas las clases a futuro"
        NotificationManager.success(mensaje, 'Éxito', 3000);
        dispatch(leer());
    }).catch((error) => {
        let mensaje = "Error al modificar las clases a futuro";
        if (error && error.detail)
            mensaje = error.detail
        NotificationManager.error(mensaje, 'ERROR');
    }).finally(() => {
        dispatch(setLoader(false));
    });
}


export const actions = {
    leer,
    crear,
    cambiarHoraClases,
};

// ------------------------------------
// Reducers
// ------------------------------------

export const reducers = {
    [LOADER]: (state, { loader }) => {
        return {
            ...state,
            loader,
        };
    },
    [ITEM_DATA]: (state, { item }) => {
        return {
            ...state,
            item,
        };
    },
};

export const initialState = {
    loader: false,
    item: {},
};

export default handleActions(reducers, initialState);
